import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M16.042 8.333c0 2.274-1.167 4.375-2.292 4.375-1.125 0-2.292-2.1-2.292-4.375 0-2.274 1.167-4.375 2.292-4.375 1.125 0 2.292 2.101 2.292 4.375Z" stroke="currentColor" stroke-width="1.5" /> <path d="M13.75 12.708s-7.083-1.458-7.917-1.666c-.833-.209-1.875-1.3-1.875-2.709 0-1.407 1.042-2.5 1.875-2.708.834-.208 7.917-1.667 7.917-1.667M5.625 11.25v3.125c0 .92.746 1.667 1.667 1.667h.416c.92 0 1.667-.747 1.667-1.667v-2.292" stroke="currentColor" stroke-width="1.5" />' }
  })
);